import React from 'react';

import Checkbox from 'components/checkbox/Checkbox';
import SelectInput from 'components/selectinput/SelectInput';
import TextInput from 'components/textinput/TextInput';

const DefaultValueField = ({
    draft,
    isEnumType,
    isTagsType,
    selectedEnumOptions,
    theme,
    onDefaultChange,
}) => (
    <div className="field-modal-field">
        <div
            className="field-modal-label"
            style={{
                color: theme.foregroundMuted,
            }}
        >
            Default Value
        </div>
        {isTagsType ? (
            <div className="field-modal-empty">Defaults are not supported for tags.</div>
        ) : draft.type === 'boolean' ? (
            <div className="field-modal-checkbox">
                <Checkbox
                    value={!!draft.default}
                    onChange={() => onDefaultChange(!draft.default)}
                    size="22"
                    label={draft.default ? 'True' : 'False'}
                />
            </div>
        ) : isEnumType ? (
            <SelectInput
                value={draft.default ?? ''}
                onChange={(e) => onDefaultChange(e.target.value === '' ? undefined : e.target.value)}
                style={{ width: '220px' }}
                disabled={selectedEnumOptions.length === 0}
            >
                <option value="">No default</option>
                {selectedEnumOptions.map((option) => (
                    <option key={option.value} value={option.value}>{option.value}</option>
                ))}
            </SelectInput>
        ) : (
            <TextInput
                placeholder={
                    draft.type === 'number'
                        ? 'e.g. 0'
                        : draft.type === 'percentage'
                            ? '0-100'
                            : draft.type === 'phone'
                                ? '(415) 555-1212'
                            : draft.type === 'email'
                                ? 'name@example.com'
                            : ''
                }
                value={
                    draft.default === undefined || draft.default === null
                        ? ''
                        : String(draft.default)
                }
                onChange={(e) => onDefaultChange(e.target.value)}
            />
        )}
    </div>
);

export default DefaultValueField;
